import { TableInstance } from "react-table";
import NoData from "../NoData/NoData";

// Token-based replacement for `components/Table/Table.tsx` scoped to
// `/certame` (design.md, "New CertameTable component, legacy Table left
// untouched") — same TableInstance/onRowClick shape, styled with design
// tokens instead of Table.styles.ts's hardcoded hex.
export default function CertameTable<T extends object>({
  instance,
  onRowClick,
}: {
  instance: TableInstance<T>;
  onRowClick?: (row: T) => void;
}) {
  const { getTableProps, getTableBodyProps, prepareRow, headerGroups, rows } =
    instance;

  return (
    <>
      <div className="w-full overflow-x-auto rounded-card border border-edge bg-surface">
        <table
          {...getTableProps()}
          cellPadding={0}
          cellSpacing={0}
          className="w-full text-ink"
        >
          <thead className="bg-surface-muted">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps()}
                    className="h-8 px-2 text-left text-[14px] font-semibold text-ink-secondary"
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  onClick={onRowClick ? () => onRowClick(row.original) : undefined}
                  className={`border-b border-edge last:border-b-0 hover:bg-surface-hover ${onRowClick ? "cursor-pointer" : ""}`}
                >
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps()}
                      className="h-10 px-2 text-[12px] font-medium text-ink"
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {!rows.length && (
        <div className="mt-2 rounded-card border border-edge bg-surface-muted">
          <NoData height={360} />
        </div>
      )}
    </>
  );
}
